module.exports = __webpack_public_path__ + "6b5565b80d157f0bd5bebefc16fec4f6.jpg";